import {
  CLEAR_DASHBOARD_CALCULATOR_DATA,
  LOAD_FREQUENT_TRANSACTIONS_FOR_DASHBOARD,
  LOAD_RECENT_TRANSACTIONS_FOR_DASHBOARD,
  LOAD_TRANSFER_SUMMARY_FOR_DASHBAORD,
  LOAD_USER_SESSION,
  SET_BENEFICIARY_DETAILS_FROM_DASHBOARD_TO_QUICKPAY,
  STORE_DASHBOARD_CALCULATOR_DATA,
  STORE_IS_NAVIGATED_FROM_DASHBOARD_INIT_TNFER
} from '../../action-contants';
import { API_URL, REQ_TIMEOUT } from '../../../utils/config';
import { handleError, showMessage } from '../common-message/message-action';
import { remitterPersonalInfo } from '../user-status/user-status-action';
import { logoutRequest } from '../authentication/authentication-action';
import { makeApiCall } from '../common/common-action';
import { activateLoader, disableLoader } from '../ui-trigger';

function loadTransferSummary(data) {
  return {
    type: LOAD_TRANSFER_SUMMARY_FOR_DASHBAORD,
    data
  };
}

function loadUserSession(data) {
  return {
    type: LOAD_USER_SESSION,
    data
  };
}

function loadRecentTransactions(data) {
  return {
    type: LOAD_RECENT_TRANSACTIONS_FOR_DASHBOARD,
    data
  };
}

function loadFrequentTransactions(data) {
  return {
    type: LOAD_FREQUENT_TRANSACTIONS_FOR_DASHBOARD,
    data
  };
}

function setBeneficiaryDetails(data) {
  return {
    type: SET_BENEFICIARY_DETAILS_FROM_DASHBOARD_TO_QUICKPAY,
    data
  };
}

export function setBeneficiaryDetailsForQuickpay(data) {
  return (dispatch) => {
    dispatch(setBeneficiaryDetails(data));
  };
}

export const saveDashboardCalculatorData = (data) => {
  return {
    type: STORE_DASHBOARD_CALCULATOR_DATA,
    data
  };
};
export const saveIsNavigatedFromDashboardInitTransfer = (data) => {
  return {
    type: STORE_IS_NAVIGATED_FROM_DASHBOARD_INIT_TNFER,
    data
  };
};
export const clearDashboardCalculatorData = () => {
  return {
    type: CLEAR_DASHBOARD_CALCULATOR_DATA
  };
};

export function submitIncompleteRegistration(props) {
  return async (dispatch) => {
    try {
      let postData = { ...props };
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/old-b2c`,
        withCredentials: true,
        data: postData
      });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        if (response.data.data.is_country_allowed) {
          await dispatch(loadUserSession(response.data.data));
          await dispatch(remitterPersonalInfo());
        } else {
          let error = response.data.data.errorMessage;
          dispatch(
            showMessage({
              text: error,
              type: 'success'
            })
          );
          setTimeout(async function () {
            let resp = await dispatch(logoutRequest());
            if (resp && resp.data && resp.data.success) {
              window.location = window.location.origin;
              window.location.reload();
            }
          }, 3000);
          return { message: error };
        }
        return response;
      }
    } catch (error) {
      dispatch(handleError(error));
      let { response } = error;
      return response || error;
    }
  };
}

export function loadRecentTransactionsForDashboard() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/transaction/transaction-history?limit=2`,
        withCredentials: true,
        timeout: REQ_TIMEOUT
      });
      if (response && response.data && response.data.success === true) {
        dispatch(loadRecentTransactions(response.data.data));
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (err) {
      dispatch(handleError(err));
      return err;
    }
  };
}

export function loadFrequentTransactionsForDashboard() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/transaction/frequent-transactions?limit=2`,
        withCredentials: true,
        timeout: REQ_TIMEOUT
      });
      if (response && response.data && response.data.success === true) {
        dispatch(loadFrequentTransactions(response.data.data));
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }

      return response;
    } catch (err) {
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}

export function loadTransferSummaryForDashboard() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/dashboard/dashboard-data`,
        withCredentials: true,
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        dispatch(loadTransferSummary(response.data.data));
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (err) {
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}

export const getRewardCouponsList = (data = {}) => {
  return async (dispatch) => {
    dispatch(activateLoader());
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/reward/coupon`,
        withCredentials: true,
        params: data
      });
      dispatch(disableLoader());
      return response;
    } catch (error) {
      dispatch(disableLoader());
      dispatch(handleError(error));
    }
  };
};
